// CORE-1735 slice 19 (D-132) — Live icon «sun»: the header's switch to the light theme.
// Hand-drawn 24-grid glyph (disc and eight rays, stroke 1.8); colour from the caller.
import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Sun: React.FC<LiveGlyphProps> = ({ size, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Circle cx={12} cy={12} r={4.2} fill={color} />
    <Path d="M12 2.5v2.6M12 18.9v2.6M2.5 12h2.6M18.9 12h2.6M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8" stroke={color} strokeWidth={1.8} strokeLinecap="round" />
  </Svg>
);
